angular.module('callX').controller('IntegrationsGoogleAdwordsReportsCtrl', ['$scope', '$stateParams', 'GoogleAdwordsService','DateService','UserService','toaster', function($scope, $stateParams, GoogleAdwordsService,DateService,UserService,toaster) {

    
    var sId = $stateParams.sid;
    var pId = $stateParams.userId;
    $scope.promoNumber = $stateParams.sid;
    $scope.tableContentLoading = false;
    $scope.noData = false;
    $scope.currentUserData = UserService.getCurrentUserData();

    $scope.orderParam = 'publisher_revenue';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };
    var init = function(){
        var TempDateObj = DateService.getDateObj();
        if(TempDateObj.timezone!=undefined){
            $scope.fetchPromoGranularData(TempDateObj.activeDate, TempDateObj.dateRangeValue);
        }
    };

    var fetchPromoGranularDataList = function(activeDate, dateRangeValue){
        $scope.tableContentLoading = true;
         var callbacks = {
            success: function(data) {
                if(data.data){
                    $scope.promoGranularList = data.data.calls;
                    $scope.tableContentLoading = false;
                    $scope.noData = false;
                }else{
                     $scope.noData = true;
                     $scope.tableContentLoading = false;
                }
                
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        GoogleAdwordsService.getPromoGranularData(pId,sId,'calls',activeDate, dateRangeValue, callbacks);
    };

     $scope.fetchPromoGranularData = function(activeDate, dateRangeValue){
            fetchPromoGranularDataList(activeDate, dateRangeValue);
    };

    $scope.$on('dateObjUpdate', function(event, dateObj) {
        $scope.fetchPromoGranularData(dateObj.activeDate, dateObj.dateRangeValue);
    });
    init();

    $scope.goBack = function(){
        window.history.back();
    };
}]);